import React from "react";
import { useTranslation } from "react-i18next";
import "./certificateListv2.css";

const CertificateList = ({ list }) => {
	const { t } = useTranslation();

	return (
		<>
			{list && (
				<>
					{list.map((cert, i) => (
						<div key={i} className="studentDetails_modal_certificate_container">
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabCertificate_issueDate_header"
										)}
									</div>
									<div className="body">{cert.issueDate || "-n/a-"}</div>
								</div>
							</div>
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabCertificate_title_header"
										)}
									</div>
									<div className="body">{cert.title || "-n/a-"}</div>
								</div>
							</div>
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabCertificate_category_header"
										)}
									</div>
									<div className="body">{cert.category || "-n/a-"}</div>
								</div>
							</div>
							{cert.skillsUsed && (
								<div className="row_container">
									<div className="">
										<div className="header">
											{t(
												"studentDetailsDialogue_body_tabProfile_tabCertificate_skillUsed_header"
											)}
										</div>
										<div className="body_withTag_container">
											{cert.skillsUsed.map((skill, index) => (
												<div key={index}>{skill}</div>
											))}
										</div>
									</div>
								</div>
							)}

							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabCertificate_certificateLink_header"
										)}
									</div>
									<div className="body">{cert.link || "-n/a-"}</div>
								</div>
							</div>
							<div className="row_container">
								<div className="">
									<div className="header">
										{t(
											"studentDetailsDialogue_body_tabProfile_tabCertificate_description_header"
										)}
									</div>
									<div className="body">{cert.description || "-n/a-"}</div>
								</div>
							</div>
						</div>
					))}
					{list.length < 1 && " Not found.."}
				</>
			)}
		</>
	);
};

export default CertificateList;
